import { useState, useEffect } from 'react';
import { apiClient } from '../services/apiClient';
import { API_ENDPOINTS } from '../config/api';

/**
 * useReceiverMeta — resolves the chat partner's display name and avatar.
 *
 * On first render it uses whatever was passed via router location.state
 * (fast path). In the background it fetches the rooms list from Laravel
 * to confirm / correct those values, which handles hard browser refreshes
 * where location.state is lost.
 */
const useReceiverMeta = (currentUserUid, otherUserUid, locationState = {}) => {
  const [receiverName, setReceiverName]     = useState(locationState.name   || '');
  const [receiverAvatar, setReceiverAvatar] = useState(locationState.avatar || null);

  useEffect(() => {
    if (!currentUserUid || !otherUserUid) return;

    const rid = [String(currentUserUid), String(otherUserUid)].sort().join('_');

    const fetchMeta = async () => {
      try {
        const response  = await apiClient.get(API_ENDPOINTS.chats.rooms);
        const roomsList = response.data?.data?.data || response.data?.data || response.data || [];
        const room      = roomsList.find(r => r.room_id === rid);

        if (room) {
          const isCurrentUserSender = String(currentUserUid) === String(room.sender_id);
          const partnerInfo         = isCurrentUserSender ? room.receiver : room.sender;

          const nameVal = partnerInfo?.full_name ||
            `${partnerInfo?.first_name || ''} ${partnerInfo?.last_name || ''}`.trim();
          const avatarVal = partnerInfo?.profile_image || null;

          if (nameVal)   setReceiverName(nameVal);
          if (avatarVal) setReceiverAvatar(avatarVal);
        }
      } catch (err) {
        console.warn('[useReceiverMeta] Failed to fetch room metadata:', err);
      }
    };

    fetchMeta();
  }, [currentUserUid, otherUserUid]);

  return { receiverName, receiverAvatar };
};

export default useReceiverMeta;
